import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UploadingFilesComponent } from './uploading-files.component';

const routes: Routes = [
  {
    path: '',
    component: UploadingFilesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UploadingFilesRoutingModule {}
